// const port = "http://localhost:8001"
const port = "https://api.5stargrading.com"

export default port;


export const formatPhoneNumberWithdot = (number) => {
    if (!number) return "";

    const cleaned = number.toString().replace(/\D/g, "");

    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "$1.$2.$3");
};

export const formatPhoneNumberWithDash = (number) => {
    if (!number) return "";

    const cleaned = number.toString().replace(/\D/g, "");

    // Use the returned formatted string
    const formatted = cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");

    return formatted;
};
